<template>
    <Breadcrumbs main="ECommerce" title="Invoice" />
    <div class="container">
        <div class="row">

            <Card8 colClass="col-sm-12">
                <div class="invoice">
                    <div>
                        <invoiceHeader />
                        <hr>
                        <invoiceProfile />
                        <invoiceTable />
                    </div>
                    <div class="col-sm-12 text-center mt-3">
                        <button class="btn btn btn-primary me-2" type="button" @click="printWindow()">Print</button>
                        <button class="btn btn-secondary" type="button">Cancel</button>
                    </div>
                </div>

            </Card8>

        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const Card8 = defineAsyncComponent(() => import("@/components/commen/card/cardData8.vue"))
const invoiceHeader = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoiceHeader.vue"))
const invoiceProfile = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoiceProfile.vue"))
const invoiceTable = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoiceTable.vue"))
function printWindow() {
    window.print();
}
</script>